"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dumpResource = void 0;
const SparkMD5 = require("spark-md5");
const byte_base64_1 = require("byte-base64");
const es6_1 = require("web-streams-polyfill/ponyfill/es6");
function dumpResource(resource, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const md5stream = new MD5Stream();
        const base64stream = new Base64Stream();
        // const streamPromises: Promise<string | void>[] = [];
        try {
            if (resource.dataStream && !resource.dataStream.locked) {
                const [md5readstream, base64readstream] = resource.dataStream.tee();
                // if (!resource.md5) {
                md5readstream.pipeTo(md5stream.writableStream);
                // }
                // if (!resource.base64data) {
                base64readstream.pipeTo(base64stream.writableStream);
                //then(() => resource.base64data = base64stream.getBase64(), console.log);
                //streamPromises.push(base64promise);
                // }
                resource.md5 = yield md5stream.md5;
                resource.base64data = yield base64stream.base64data;
                return `<resource>
                    <data encoding="base64">${resource.base64data}</data>
                    <mime>${resource.mimetype}</mime>
                    ${resource.width ? `<width>${resource.width}</width>` : ''}
                    ${resource.height ? `<height>${resource.height}</height>` : ''}
                    <resource-attributes>
                        <file-name>${resource.filename}</file-name>
                    </resource-attributes>
                </resource>`;
            }
        }
        catch (error) {
            // Probably could not read stream
            console.log(error);
        }
        return "";
    });
}
exports.dumpResource = dumpResource;
class MD5Stream {
    constructor() {
        const spark = new SparkMD5.ArrayBuffer();
        this.md5 = new Promise((r) => this.resolve = r);
        const resolve = this.resolve;
        this.writableStream = new es6_1.WritableStream({
            write(chunk) {
                return new Promise((r) => {
                    if (chunk) {
                        if (chunk instanceof Uint8Array) {
                            spark.append(chunk.buffer);
                        }
                    }
                    r();
                });
            },
            close() {
                if (resolve)
                    resolve(spark.end());
            }
        });
    }
}
class Base64Stream {
    constructor() {
        let base64string = "";
        this.base64data = new Promise((r) => this.resolve = r);
        const resolve = this.resolve;
        this.writableStream = new es6_1.WritableStream({
            write(chunk) {
                return new Promise((r) => {
                    if (chunk) {
                        if (chunk instanceof Uint8Array) {
                            base64string += byte_base64_1.bytesToBase64(chunk);
                        }
                    }
                    r();
                });
            },
            close() {
                if (resolve)
                    resolve(base64string);
            }
        });
    }
}
